"use client";
import React from "react";
var ConfigCatContext = React.createContext(void 0);
ConfigCatContext.displayName = "ConfigCatContext";
export default ConfigCatContext;
